// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"53":"webfontloader","594":"about","857":"report","966":"login"}[chunkId] + "." + {"53":"9380816b","594":"c5d306e4","857":"b84d3c8e","966":"c2e693db"}[chunkId] + ".js";
};